import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ButtonComponent,
  ButtonSize,
  ButtonType,
} from '@app/components/button';
import {
  TextColor,
  TextComponent,
  TextHeight,
  TextSize,
  TextType,
  TextWeight,
} from '@app/components/text';
import {
  ViewAlign,
  ViewComponent,
  ViewDirection,
  ViewJustify,
} from '@app/components/view';
import { Spacing } from '@app/shared/types';

export interface ActionCollectionItem {
  id: string;
  title: string;
  subTitle: string;
  label?: string;
}

@Component({
  selector: 'app-action-collection',
  standalone: true,
  imports: [CommonModule, ButtonComponent, ViewComponent, TextComponent],
  templateUrl: './action-collection.component.html',
  styleUrl: './action-collection.component.css',
})
export class ActionCollectionComponent {
  @Input() action: ButtonType;
  @Input() collection!: ActionCollectionItem[];
  @Input() titleSize: TextSize = TextSize.BODY_1;
  @Output() handleAction = new EventEmitter();
  ButtonSize = ButtonSize;
  ButtonType = ButtonType;
  TextSize = TextSize;
  TextWeight = TextWeight;
  TextHeight = TextHeight;
  Spacing = Spacing;
  TextColor = TextColor;
  ViewDirection = ViewDirection;
  ViewJustify = ViewJustify;
  ViewAlign = ViewAlign;
  TextType = TextType;

  onAction(item: ActionCollectionItem) {
    this.handleAction.emit(item);
  }
}
